import styled from 'styled-components';

export const CenterBox = styled.div`
    > div,
    > form {
        background: #fff;
        margin: 10px auto;
        padding: 25px;
        @media screen and (min-width: 480px) {
            margin: 20px auto;
            maxwidth: calc(100% - 100px);
            width: 500px;
        }

        h2 {
            font-size: 1.65rem;
            line-height: 2.5rem;
            margin-bottom: 1.25rem;
        }
    }
`;
